import { Check, CircleAlert, Loader2 } from 'lucide-react';

export default function CanvasScriptPrecheck({ precheck, preview, library, disabled, onRetry }) {
  const { result, checking, error } = precheck;
  const issues = result?.checks?.filter(check => !check.passed) || [];
  return <section className="canvas-script-precheck" aria-labelledby="canvas-script-precheck-title" aria-busy={checking}>
    <div className="canvas-script-precheck-head"><h3 id="canvas-script-precheck-title">拆镜预检查</h3>
      {result && <span>{result.checks.length - issues.length} / {result.checks.length} 项通过</span>}
      {(error || result) && <button type="button" disabled={disabled || checking} onClick={onRetry}>重新检查</button>}
    </div>
    {checking ? <p role="status"><Loader2 size={14} className="animate-spin" />正在检查正文、年代和制作参数…</p>
      : error ? <p role="alert"><CircleAlert size={14} />{error}</p>
        : result ? <>
          <p role={issues.length ? 'alert' : 'status'} className={issues.length ? 'is-failed' : 'is-passed'}>
            {issues.length ? <CircleAlert size={14} /> : <Check size={14} />}
            {issues.length ? `还有 ${issues.length} 项不符合条件，补齐后才能创建并进入画布。` : '预检查全部通过，可以创建并进入画布。'}
          </p>
          {issues.length > 0 && <ul>{issues.map(issue => <li key={issue.id}><strong>{issue.label}</strong><p>{issue.message}</p></li>)}</ul>}
          <details><summary>查看全部检查条件</summary><ul>{result.checks.map(check => <li key={check.id} className="canvas-script-precheck-item">
            {check.passed ? <Check size={13} aria-hidden="true" /> : <CircleAlert size={13} aria-hidden="true" />}<div><strong>{check.label} · {check.passed ? '通过' : '未通过'}</strong><p>{check.message}</p></div>
          </li>)}</ul></details>
          {issues.length > 0 && <p>{library ? '请在写作台修改并保存这集正文或故事资料，再点击「重新检查」。' : '请在上方正文中补充或修改，停止输入后会自动重新检查。'}</p>}
        </> : <p>{preview ? '登录后可按画布 Agent 的要求检查剧本。' : library ? '选择已定稿的一集后自动检查，全部通过后才能进入。' : '粘贴或上传正文，多集剧本选定一集后自动检查。'}</p>}
  </section>;
}
